<template>
  <v-list-item class="pl-0">
    <v-list-item-icon class="mr-1">
      <v-icon>{{ icon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>{{ title }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
export default {
  props: {
    icon: String,
    title: String,
  },
};
</script>